import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { HiOutlinePhone, } from 'react-icons/hi';


import {
    FooterContainer,
    FooterWrap,

    FooterLogo,
    Logo,
    FooterCallContainer,

    SocialMedia,
    SocialMediaWrap,
    WebsiteRights,
    FooterCall,
} from './FooterElements'

import logo from '../../img/logo.png';
import theme from '../../const/theme';


const Footer = () => {
    const toggleHome = () => {
        scroll.scrollToTop()
    }

    return (
        <>
            <FooterContainer>
                <FooterWrap>

                    <SocialMedia>
                        <SocialMediaWrap>
                            <FooterLogo to="home"

                                smooth={true}
                                duration={500}
                                spy={true}
                                exact="true"
                                offset={-100}>
                                <Logo src={logo} />

                            </FooterLogo>
                            <FooterCallContainer>
                               <FooterCall>
                               Trusted Process Services
                               </FooterCall>
                            </FooterCallContainer>
                        <WebsiteRights> &copy; {new Date().getFullYear()} All rights reserved.</WebsiteRights>
                        </SocialMediaWrap>
                    </SocialMedia>
                </FooterWrap>
            </FooterContainer>
        </>
    )
}

export default Footer

const styles = {
    arrowLeft: {
        width: 0,
        height: 0,
        backgroundColor: 'transparent',
        borderStyle: 'solid',
        borderTopWidth: 7,
        borderRightWidth: 7,
        borderBottomWidth: 7,
        borderLeftWidth: 0,
        borderTopColor: 'transparent',
        borderRightColor: theme.COLORS.PRIMARY,
        borderBottomColor: 'transparent',
        borderLeftColor: 'transparent',
        marginLeft: 20,
    },
}